import { useEffect, useState } from "react";
import { IDropdown, ILead } from "../../models/BaseModel";
import { Button } from "primereact/button";
import { useRef } from "react";
import { Dialog } from "primereact/dialog";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../shared/Fetch";
import { JVDate } from "../../shared/JVDate";
import { format } from "date-fns";
import { confirmDialog } from "primereact/confirmdialog";

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    hasPermission: (pageName: string, featureName?: string) => boolean,
    reloadData: () => void,
}

export interface IEmptyDevice {
    macAddress: "",
    device_Name: null,
    accessoriesDealPrice: null
};

const schema = yup.object({
});
interface IAccesoriesDrop extends IDropdown {
    accessoriesPrice?: number
}

export const AddAccessories = (props: Iprops) => {
    const toast = useRef(null);
    const [tableData, setTableData] = useState({ data: [], count: 0, leadDetails: 0, loading: false, status: [] } as { data: ILead[], count: number, leadDetails: number, loading: boolean, status: { id: number, name: string, count: number }[] });
    const [editRow, setEditRow] = useState<ILead | null>(null);
    const [accessories, setAccessories] = useState<IAccesoriesDrop[]>();

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const accessoriesName = watch("accessoriesID");
    const accessoriesCost = accessories?.find((item) => item.id === accessoriesName)?.accessoriesPrice || 0;
    setValue("accesoriesBasePrice", accessoriesCost);

    const onHide = () => {
        props.hideDialog();
    }


    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`Leads/getAttachAccessoriesById${props.singleData.id ? '/' + props.singleData.id : ''}`, "GET", null, null, props.toast);
        if (response) {
            const data: { data: ILead[], count: number, leadDetails: number, status: { id: number, name: string, count: number }[] } = await response.json();
            setTableData({ data: data.data, count: data.count, status: data.status, loading: false, leadDetails: data.leadDetails });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }


    const saveToDB = async (body: ILead) => {
        let endpoint = `Leads/AddAttachAccessories/${props.singleData.id}`;
        if (editRow?.id) {
            endpoint = `Leads/UpdateAttachAccessories/${editRow.id}`;
        }
        const response = await Fetch(endpoint, "POST", body, null, props.toast);
        if (response) {
            // onHide();
            props.toast.current.show({ severity: 'success', detail: editRow ? "Updated Successfully" : "Added Successfully", life: 3000 });
            loadTableData();
            props.reloadData();
                    reset({ macAddress: "", device_Name: null, accessoriesDealPrice: 0 });

        }
    }

    const onSubmit = (data: any) => {
        if (Number(data.accessoriesDealPrice) > Number(data.accesoriesBasePrice)) {
            props.toast.current.show({ severity: 'error', detail: "Deal Price cannot be greater than Base Price", life: 3000 });
            return;
        }
        saveToDB(data);
    }

    const onEdit = (rowData: any) => {
        setEditRow(rowData);
        reset({
            ...rowData,
        });
    };

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);



    const loadAccessories = async () => {
        const response = await Fetch("Accessories/dropdown", "GET", null, null, null);
        if (response) {
            setAccessories(await response.json());
        }
    }

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    useEffect(() => {
        loadAccessories();
    }, [props.open]);

    const toggleVal = async (id?: number) => {
        const response = await Fetch(`Leadrequirements/toggleAttachDevicestatus/${id}`, "PUT", null, null, props.toast);
        if (response) {
            let message: string = " Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };
    const Remove = async (rowData: any) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`Leads/deleteAttachAccessories/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.accessoriesName}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const actionBodyTemplate = (rowData: any) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-text p-button-sm" onClick={() => onEdit(rowData)} tooltip="Edit" />
                <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }} ></Button>
            </div>
        );
    };

    const Clear = () => {
        reset({});
        reset({ macAddress: "", device_Name: null, accessoriesDealPrice: 0 });
        setEditRow(null)
    }

    return (
        <>
            {/* </> <Toast ref={toast} /> */}
            <Dialog visible={props.open} style={{ width: '60vw' }} header={`Add a New Accessories `} modal className="p-fluid" onHide={onHide}>
                {/* <h3>Add a New Accessories </h3> */}
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                    <JVDropdown column={6} label="Select Accessories" control={control} options={accessories} optionLabel="accessoriesName" optionValue="id" name="accessoriesID" placeholder="Select Accessories" />
                    <JVInput column={6} label="Mac Address" control={control} name="macAddress" />
                    <JVInput column={6} label="Base Price($)" control={control} name="accesoriesBasePrice" type="number" disabled />
                    <JVInput column={6} label="Deal Price($)" control={control} name="accessoriesDealPrice" type="number" />
                    <Button className="mt-4 h-3rem w-6rem ml-4 mr-2" type="submit">SUBMIT</Button>
                    <Button className="mt-4 h-3rem w-6rem p-button-outlined" type="button" onClick={Clear}>CLEAR</Button>
                </form>
                <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }}></div>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small"
                    value={tableData.data}
                    emptyMessage="No Data found."
                    loading={tableData.loading}
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="accessoriesName" header="Accessories" />
                    <Column field="accesoriesBasePrice" header="Base Price" />
                    <Column field="accessoriesDealPrice" header="Deal Price" />
                    <Column field="macAddress" header="Mac Address" />
                    <Column field="createdByName" header="Created By" />
                    <Column field="createdAt" header="Created At" body={(rowData) => format(new Date(rowData.createdAt+"Z"), 'dd/MM/yyyy')} />
                    {/* <Column field="is_Active" header="Active" sortable body={lostStatusBody} /> */}
                    <Column header="Action" body={actionBodyTemplate} />
                </DataTable>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </Dialog>

        </>
    );
};
